import React from "react";
//component
import SwiperCarousel from "../Swiper/SwiperCarousel";
//mock data
import { useEffect, useState } from "react";

import { items } from "../../mocks/slideData";
import { motion } from "framer-motion";
import content from "../../content.json";

const Hero = () => {
  // dark mode

  const [theme, setTheme] = useState("light");
  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);
  const handleThemeSwitch = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <div className=" overflow-x-hidden">
      <div className="mb-44 bubble  top-0 bg-gradient-0 h-full dark:bg-[#212121] dark:from-[#212121] from-[#fab8c4b3] dark:to-[#212121] to-white items-center justify-center ">
        <motion.div
          className="z-50"
          // initial={{ y: -500, }}
          animate={{ y: [-80, 95, 85, -80], x: [-200, -800, -70, -200] }}
          transition={{ duration: 40, repeat: Infinity }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-31.png"
            className="z-50 absolute top-32 opacity-90 right-96"
            alt=""
          />
        </motion.div>
        <motion.div
          initial={{ x: 500, opacity: 0, scale: 0.5 }}
          animate={{ x: 0, opacity: 1, scale: 1 }}
          transition={{ duration: 2 }}
        >
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-14.png"
            className="absolute top-96 opacity-90 left-56"
            alt=""
          />
        </motion.div>
        <div className="flex  relative flex-col items-center justify-center mb-44">
          <img
            src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-36.png"
            alt=""
            className=" dark:hidden absolute top-0 left-11"
          />
          <img
            src="https://cdn.discordapp.com/attachments/859118146086764578/1134722964869369926/image-removebg-preview_3.png"
            alt=""
            className="z-0 opacity-0 dark:opacity-100 absolute top-0 w-500 left-11"
          />
          <h1 className=" dark:text-white flex justify-center text-center mt-40 text-2xl mx-auto max-w-7xl">
            {content.home.interface.h1}
          </h1>
          <SwiperCarousel carouselData={items as any} />
        </div>
      </div>

      {/* dark mode toggle  */}

      <div className="fixed top-1/2 flex z-50">
        <div className="bg-blue-400 z-50 -mr-4 w-5"></div>
        <button
          className="p-2 px-3 rounded-full z-50  bg-blue-400"
          onClick={handleThemeSwitch}
        >
          <svg
            stroke="white"
            fill="white"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="2em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Hero;
